// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__qfzTp","addWidgetButton":"Header_addWidgetButton__10_vi","dashboardTabs":"Header_dashboardTabs__1358O","active":"Header_active__34m0W"};